import React from 'react';
import { blogs1Data } from './data';
import './Styles/Blogs1.scss';
import image from '../../../Assets/Cards/whyBlog.webp';
import BlogCard from '../../Shared/Cards/BlogCard/Card';
const Blogs1=()=>{
    return(
        <div className="blogs-1">
            <BlogCard 
            image={image}
            title="Why design must help business stay North Star-focused in 2021 in partext company in the world."
             desc="Heidi Munc: In the beginning when a UX team would work with business partners, they’d focus on the negatives, like time and cost. They realized, however, how powerful reframing those insights as benefits could be…"
            by="Liz steelman"
            styles="big-blog"
            sub="design"
            />
           <div className="blogs2">
           {blogs1Data.map((d,i) =>{
               return(
                   <BlogCard styles="small-blog" {...d}/>
               )
           })}
           </div>
        </div>
    )
};
export default Blogs1;